import type { HttpDelete } from '@/shared/infra/http'
import type { RemoveChannelMember } from '@/modules/connect/use-cases'
import { mapChannelAdminError } from './map-channel-admin-error'

export class EdgeRemoveChannelMemberRepository {
  constructor(private readonly http: HttpDelete) {}

  execute: RemoveChannelMember = async (params) => {
    const query =
      `?orgId=${encodeURIComponent(params.orgId)}` +
      `&orgType=${params.orgType}` +
      `&userId=${encodeURIComponent(params.userId)}`
    try {
      await this.http.delete<unknown>({
        url: `/connect/channels/${encodeURIComponent(params.channelId)}/members${query}`,
      })
    } catch (err) {
      throw mapChannelAdminError(err)
    }
  }
}
